import { Injectable, inject } from "@angular/core";
import { SwUpdate, VersionReadyEvent } from "@angular/service-worker";
import { filter } from "rxjs";
import { Permission } from "src/app/common/enums/permissions";
import { AuthService } from "src/app/core/authentication/auth.service";
import { SnackBarService } from "../shared/services/snack-bar.service";
import { Messages } from "src/app/common/enums";

@Injectable({ providedIn: 'root' })
export class UpdateService {
  authService = inject(AuthService);
  private snackbarService = inject(SnackBarService);



  constructor() {
    const swUpdate = inject(SwUpdate);

    swUpdate.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe({
        next: () => {
          if (this.isQrCodesAccount()) {
            document.location.reload();
          } else {
            this.snackbarService.openSuccessSnackBar(Messages.NewVersionIsAvailable, undefined, true);
          }
        }
      });
  }

  private isQrCodesAccount(): boolean {
    return this.authService.hasPermission(Permission.QrCode);
  }
}